import type { IOrderDetail } from '@pu/mpp-ui/components/order-detail';
import { INewOrderParams, IOrderDisplay, IOrdersFilters } from 'core/model/interfaces/order.interface';
import { ordersData } from './orders.data';
import {
  mapCreatedOrderDTOToDisplayOrder,
  mapDatesToOrdersParams,
  mapOrderDetailResponseToOrderDetail,
  mapOrdersDTOtoDisplayOrder,
  mapOrderToCreateOrderRequestParams,
} from './orders.mapper';

export const ordersService = {
  createOrder: async (params: INewOrderParams, customerId: number, uuid?: string) => {
    const mappedParams = mapOrderToCreateOrderRequestParams(params);
    const response = await ordersData.createOrder(mappedParams, customerId, uuid);
    return mapCreatedOrderDTOToDisplayOrder(response);
  },
  getOrders: async (params: IOrdersFilters, customerId: number): Promise<Array<IOrderDisplay>> => {
    const mappedParams = mapDatesToOrdersParams(params);
    const response = await ordersData.getOrders(mappedParams, customerId);
    return mapOrdersDTOtoDisplayOrder(response);
  },
  getOrderDetail: async (orderId: string, sourceId: number, customerId: number): Promise<IOrderDetail> => {
    const rawOrderDetail = await ordersData.getOrderDetail(orderId, sourceId, customerId);
    return mapOrderDetailResponseToOrderDetail(rawOrderDetail);
  },
};
